interface PortfolioItem {
  id: string;
  imageUrl: string;
}

interface PortfolioGalleryProps {
  items: PortfolioItem[];
}

export default function PortfolioGallery({ items }: PortfolioGalleryProps) {
  if (!items.length) return null;

  return (
    <div className="bg-bg-surface rounded-2xl border border-border p-6 shadow-sm mb-6">
      <h2 className="text-lg font-bold text-text-primary mb-4 flex items-center gap-2">
        <span style={{ color: 'var(--color-brand)' }}>◼</span>
        Портфолио
        <span className="text-sm font-normal text-gray-400">({items.length} фото)</span>
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {items.map((item) => (
          <div key={item.id} className="aspect-square rounded-xl overflow-hidden bg-bg-muted">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={item.imageUrl}
              alt="Работа специалиста"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
